// extracted by mini-css-extract-plugin
module.exports = {"SelectedHeroesBar":"SelectedHeroesBar__SelectedHeroesBar__3Avw8"};